const settingRouter = [
    {
        path: "list-settingV2",
        name: "settingV2",
        component: () => import("@/views/admin/settingV2"),
        default: true,
        meta: {
            model: "setting",
            // requiresAuth: true,
        },
    },
    // {
    //     path: "list-settingV2/add",
    //     name: "addSettingV2",
    //     component: () => import("@/views/admin/settingV2/function"),
    //     default: true,
    //     meta: {
    //         model: "setting",
    //         // requiresAuth: true,
    //     },
    // },
    {
        path: "list-settingV2/edit/:id",
        name: "editSettingV2",
        component: () => import("@/views/admin/settingV2/function"),
        default: true,
        meta: {
            model: "setting",
            // requiresAuth: true,
        },
    },
];
export default settingRouter;